









import { Component, Vue } from 'vue-property-decorator';
import ModuleForm from './components/moduleForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { moduleListInstance } from '@/model/ModuleListClass';

@Component({
  components: {
    ModuleForm,
  },
})
export default class CreateModule extends Vue {
  private moduleListInstance = moduleListInstance;
  get moduleInfo() {
    return this.moduleListInstance.createModule();
  }
  private createModule(module: IModule.IRequest.IUpdateModuleParams): Promise<string> {
    return new Promise((reslove, reject) => {
      this.moduleListInstance.requestCreateItem(module).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
}
